import { PlatformCode } from 'type/common';
import { api, report_api } from './api';

export const report_apis = {
	setReport: (platform: PlatformCode, platform_pk: string) => {
		return report_api.post(`report/${platform}/${platform_pk}`);
	},
	getReport: async (platform: PlatformCode, platform_pk: string) => {
		const data = await api.get(`report/${platform}/${platform_pk}`);

		return data.data.result;
	},

	getEgData: async (platform: PlatformCode, platform_pk: string, section: string) => {
		const data = await api.get(`report/${platform}/${platform_pk}/section/${section}`);

		return data.data.result;
	},
};
